import {KarenTextStyles} from "../KarenTextStyles";

export class KarenMultiplierFontText extends PIXI.Text {
    private _reelId: number = -1;

    constructor(multName: string, reelId: number) {
        super("x1");
        this.initObjects();
        this._reelId = reelId;
        this.name = multName + "_" + this._reelId;
    }

    public setPositionX(xPosition: number): void {
        this.position.x = xPosition;
    }

    public updateInfectiousStyle(): void {
        //Infectious Color
        this.style = KarenTextStyles.INFECTIOUS_MULTIPLIER_TEXT_STYLE;
    }

    private initObjects(): void {
        //defaultt redColor
        this.style = KarenTextStyles.MULTIPLIER_TEXT_STYLE;
        this.position.set(36, 26);
        this.anchor.set(0.5);
    }
}
